import React from 'react';
import {withTranslation} from 'react-i18next';
import {Field, Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Row} from 'reactstrap';
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import {required} from '../helpers/Validators';
import FieldError from '../components/FieldError';
import {application} from '../constants/configs';
import {trim, filter, forEach} from 'lodash';
import Select from 'react-select';

class TradeFeeUserForm extends React.Component {
  createUser = async values => {
    this.props.addUser(values);
    ModalManager.close({
      isOpen: false
    });
  };

  updateUser = async values => {
    this.props.editUser(values);
    ModalManager.close({
      isOpen: false
    });
  }

  ReactSelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      placeholder={this.props.t('Select')}
    />
  );

  getUserOptions = () => {
    const {t, policy} = this.props;
    const options = [
      {label: t(application.platformName), value: `__${application.platformName}__`},
      {label: t('innodax'), value: '__innodax__'},
    ];
    return filter(options, item => {
      let isInclude = true;
      forEach(policy.levels.fiat[0].fees, fee => {
        if (fee.user === item.value) {
          isInclude = false;
        }
      });
      return isInclude;
    });
  };

  render() {
    const {t, user} = this.props;
    return(
      <FinalForm
        onSubmit={user ? this.updateUser : this.createUser}
        initialValues={{user: {label: t(trim(user, '_')), value: user}}}
        render={({handleSubmit, submitting, pristine, hasValidationErrors}) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <span>
                    {t('User')}
                    <span className="required">*</span>
                  </span>
                  <Field
                    name="user"
                    validate={required}
                    options={this.getUserOptions()}
                    component={this.ReactSelectAdapter}
                    closeMenuOnSelect={false}
                  />
                  <FieldError name='role' />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col>
                  <LoaderButton
                    color="success"
                    onClick={handleSubmit}
                    loading={submitting}
                    disabled={pristine || hasValidationErrors || submitting}
                    className="text-center"
                    style={{minWidth: '100px'}}>
                    {user ? t('Update') : t('Submit')}
                  </LoaderButton>
                  <Button
                    color="grey"
                    onClick={() =>{
                      ModalManager.close({
                        isOpen: false
                      });
                    }}
                    className="text-center mx-2"
                    style={{minWidth: '100px'}}>
                    {t('Close')}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      />
    );
  }
}

export default withTranslation()(TradeFeeUserForm);
